module.exports = __webpack_public_path__ + "img/hiw-user.6e4f1e31.svg";